import { SMART_CONTRACT_TYPES, SMART_CONTRACT_PLUGIN_IDS } from "@/components/SmartContractDesigner/smartContractPluginIDs";
import Vue from "vue";
import { recursivelyCreateNodes, flattenFunctionBody, getObjectDiagramData } from "../../../pages/main/views/SmartContractDesigner/utils/smart-contract.utils";

export const setSelectedPluginUuid = (state, payload) => {
    state.selectedPluginUuid = payload;
};
export const setSelectedPluginCode = (state, payload) => {
    state.selectedPluginCode = payload;
};
export const setAppBlockchainLanguage = (state, payload) => {
    state.appBlockchainLanguage = payload;
};

export const setNumberOfSc = (state, payload) => {
    state.scNumber = payload;
};
export const setSmartContractValidationModel = (state, payload) => {
    state.smartContractValidationModel = payload;
};
export const setRedoCache = (state, payload) => {
    if (payload.data && payload.data.nodes) {
        delete payload.data.nodes;
    }
    if (payload.data) {
        state.redoCache[payload.id] = payload.data;
    }
};

export const setDiagramData = (state, diagramData) => {
    let functionIndex;
    if (state.inEditFunction) {
        functionIndex = state.applicationFunctions.findIndex(func => func.id === state.inEditFunction.id);
    }
    if (functionIndex !== undefined && functionIndex !== -1) {
        Vue.set(state.applicationFunctions[functionIndex], "diagramData", diagramData);
        Vue.set(state.inEditFunction, "diagramData", diagramData);
        Vue.set(state.applicationFunctions, functionIndex, state.applicationFunctions[functionIndex]);
    }
};

export const addEntryToSelectedDataset = (state, payload) => {
    if (payload.data != null) {
        payload.data.index = state.selectedPluginData[payload.property].length;
        state.selectedPluginData[payload.property].push(payload.data);
        state.selectedPluginData.description = payload.description;
    } else {
        state.selectedPluginData.description = payload.description;
    }
};
export const updateEntryToSelectedDataset = (state, payload) => {
    if (payload.data != null) {
        Vue.set(state.selectedPluginData[payload.property], payload.index, payload.data);
        state.selectedPluginData.description = payload.description;
    } else {
        state.selectedPluginData.description = payload.description;
    }
};
export const removeEntryFromSelectedDataset = (state, payload) => {
    state.selectedPluginData[payload.property].splice(payload.data, 1);
    state.selectedPluginData[payload.property] = state.selectedPluginData[payload.property].map((elem, index) => {
        elem.index = index;
        return elem;
    });
};
export const modifyNestedPropertyOnCurrentFunction = (state, payload) => {

};

export const setSelectedFunction = (state, payload) => {
    state.selectedFunction = payload;
};

export const addNode = (state, payload) => {
    let node = {
        index: state.inEditFunction.body.length,
        nodeType: SMART_CONTRACT_TYPES[payload.PLUGIN_ID],
        id: payload.PLUGIN_UUID,
        description: ""
    };

    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_IF) {
        node.condition = "";
        node.trueList = [];
        node.falseList = [];
    }

    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FUNCTION_CALL) {
        node.isStatic = false;
        node.functionName = null;
        node.functionId = null;
        node.contractId = null;
        node.contractName = null;
        node.request = [];
        node.response = [];
    }

    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EMIT_EVENT) {
        node.eventName = "";
        node.eventId = "";
        node.request = [];
    }

    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_ASSIGN) {
        node.assignList = [];
    }
    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DECLARE) {
        node.declareList = [];
    }
    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FOR) {
        node.variable = "";
        node.start = "";
        node.end = "";
        node.step = 1;
        node.direction = "";
        node.forList = [];
    }
    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DO_WHILE) {
        // node.condition = "";
        node.trueList = [];
    }
    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_WHILE) {
        // node.condition = "";
        node.trueList = [];
    }
    if (payload.PLUGIN_ID === SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EXPRESSION) {
        node.customCode = "";
    }
    if (payload.cacheData) {
        node = { ...node, ...payload.cacheData };
    }
    state.inEditFunction.body.push(node);
};

export const removeNode = (state, nodeUuid) => {
    const contentIndex = state.inEditFunction.diagramData.content.findIndex(plugin => plugin.uuid === nodeUuid);
    state.inEditFunction.diagramData.content.splice(contentIndex, 1);
    const nodes = recursivelyFindNodes(state.inEditFunction.body, nodeUuid);
    const index = nodes.findIndex(node => node.id === nodeUuid);

    state.redoCache[nodeUuid] = { ...nodes[index] };
    nodes.splice(index, 1);
    nodes.forEach((elem, index) => {
        elem.index = index;
    });
};
export const flattenInEditFunction = (state) => {
    state.inEditFunction.body = flattenFunctionBody(state.inEditFunction.body);
};

export const setIndexesForProvidedFunction = (state, func) => {
    const nodesToSet = [];
    const reducedToMainNodes = flattenFunctionBody(func.body);
    func.diagramData = typeof func.diagramData === "string" ? JSON.parse(func.diagramData) : func.diagramData;
    func.diagramData = typeof func.diagramData === "string" ? JSON.parse(func.diagramData) : func.diagramData;
    reducedToMainNodes.push(...getMissingNodes(reducedToMainNodes, func.diagramData));
    const plugins = func.diagramData.content;
    const { connectors } = func.diagramData;
    const startPlugin = plugins.find(plugin => plugin.id === SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN);
    const endPlugin = plugins.find(plugin => plugin.id === SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN);
    func.body = reducedToMainNodes.length > 0 && startPlugin && endPlugin ? recursivelyCreateNodes(nodesToSet, plugins, connectors, reducedToMainNodes, startPlugin.outgoing) : func.body;
    // TODO: Prevent general end from being added this is a lazy workaround:
    func.body = func.body.filter(node => node.type !== SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN);
    state.formattedPreviewFunction = func;
};

export const setIndexesForCurrentFunction = (state, payload) => {
    const nodesToSet = [];
    const reducedToMainNodes = flattenFunctionBody(state.inEditFunction.body);
    reducedToMainNodes.push(...getMissingNodes(reducedToMainNodes, state.inEditFunction.diagramData));
    const plugins = state.inEditFunction.diagramData.content;
    const { connectors } = state.inEditFunction.diagramData;
    const startPlugin = plugins.find(plugin => plugin.id === SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN);
    const endPlugin = plugins.find(plugin => plugin.id === SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN);
    state.inEditFunction.body = reducedToMainNodes.length > 0 && startPlugin && endPlugin ? recursivelyCreateNodes(nodesToSet, plugins, connectors, reducedToMainNodes, startPlugin.outgoing) : state.inEditFunction.body;
    // TODO: Prevent general end from being added this is a lazy workaround:
    state.inEditFunction.body = state.inEditFunction.body.filter(node => node.nodeType !== SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN && node.type !== "GENERAL_END_PLUGIN");
};

const getMissingNodes = (reducedNodes, diagramData) => {
    const plugins = typeof diagramData === "string" ? JSON.parse(diagramData).content : diagramData.content;
    const nodesUuids = reducedNodes.map(node => node.id);
    return plugins.filter(plugin => nodesUuids.indexOf(plugin.uuid) === -1).map((missingPlugin, index) => {
        let type = null;
        const plugin = plugins.find(plugin => plugin.uuid === missingPlugin.uuid);
        if (plugin.id === SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR) type = SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR;
        if (plugin.id === SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN) type = SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN;
        if (plugin.id === SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN) type = SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN;
        return {
            id: plugin.uuid,
            index: (reducedNodes.length - 1) + index,
            type
        };
    });
};

const recursivelyFindNodes = (nodes, toFindUuid) => {
    const check = nodes.find(node => node.id === toFindUuid);
    if (check) return nodes;
    for (let i = 0; i < nodes.length; i++) {
        const checkUuid = nodes[i].id === toFindUuid ? nodes[i] : null;
        if (checkUuid) return nodes;
        if (nodes.nodes) recursivelyFindNodes(nodes.nodes);
    }
    return nodes.find(node => node.id === toFindUuid) || recursivelyFindNodes(nodes);
};

export const setSelectedPlugin = (state, payload) => {
    function getPluginData(nodes, toFindUuid) {
        function recursiveCheck(nodes) {
            const check = nodes.find(node => node.id === toFindUuid);
            if (check) return check;
            for (let i = 0; i < nodes.length; i++) {
                const checkUuid = nodes[i].id === toFindUuid ? nodes[i] : null;

                if (checkUuid) return checkUuid;
                if (nodes.nodes) recursiveCheck(nodes.nodes);
            }
        }
        return nodes.find(node => node.id === toFindUuid) || recursiveCheck(nodes);
    }
    state.selectedPluginData = !payload || !state.inEditFunction ? null : getPluginData(state.inEditFunction.body, payload.PLUGIN_UUID);
    state.selectedPluginUuid = !payload ? payload : payload.PLUGIN_UUID;
    state.selectedPluginCode = !payload ? payload : payload.PLUGIN_ID;
};

export const setApplicationFunctions = (state, payload) => {
    state.applicationFunctions = payload;
};
export const setSmartContractList = (state, payload) => {
    state.smartContractList = payload;
};

export const setFunctionSelected = (state, payload) => {
    state.functionSelected = payload;
};

export const setStaticVariables = (state, payload) => {
    state.staticVariables = payload;
};

export const deleteFunction = (state, functionId) => {
    state.applicationFunctions = state.applicationFunctions.filter(app => app.id !== functionId).map((func, index) => {
        func.index = index;
        return func;
    });
    state.functionsSignatures = state.functionsSignatures.filter(func => func.id !== functionId);
};

export const updateFunction = (state, payload) => {
    const index = state.applicationFunctions.findIndex(func => func.id === payload.id);
    Vue.set(state.applicationFunctions, index, { ...payload });
    updateFunctionsSignatures(state, payload);
    if (payload.id === state.inEditFunction.id) {
        Vue.set(state, "inEditFunction", payload);
    }
};
export const addFunction = (state, payload) => {
    state.applicationFunctions.push(payload);
    updateFunctionsSignatures(state, payload);
};
const updateFunctionsSignatures = (state, funcData) => {
    const signatureIndex = state.functionsSignatures.findIndex(signature => signature.id === funcData);
    // is a new function
    if (signatureIndex === -1) {
        state.functionsSignatures.push(funcData);
    } else { // existing signature that needs update
        Vue.set(state.functionsSignatures, signatureIndex, funcData);
        // state.functionsSignatures[signatureIndex] = funcData;
    }
};
export const setFunctionsSignatures = (state, payload) => {
    state.functionsSignatures = payload;
};

export const removeVariable = (state, payload) => {
    const key = payload.parameter ? "inParameters" : "outParameters";
    state.applicationFunctions.find(func => func.id === payload.functionUuid)[key].splice(payload.index, 1);
};

export const updateFunctionVariableIndexes = (state, payload) => {
    const key = payload.parameter ? "inParameters" : "outParameters";
    state.applicationFunctions = state.applicationFunctions.find(func => func.id === payload.functionUuid)[key].map((elem, index) => {
        elem.index = index;
        return elem;
    });
};

export const setExistingFunctionsAsDDL = (state, payload) => {
    state.existingFunctionsAsDDL = payload;
};

export const setInEditFunction = (state, payload) => {
    if (!payload) {
        setSelectedPlugin(state, payload);
    }
    state.inEditFunction = !payload ? payload : [payload].map(func => {
        getObjectDiagramData(func);
        func.diagramData.content.filter(plugin => plugin.id === SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR || plugin.id === SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN || plugin.id === SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN).forEach((plugin) => {
            let type = null;
            if (plugin.id === SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR) type = SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR;
            if (plugin.id === SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN) type = SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN;
            if (plugin.id === SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN) type = SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN;
            func.body.push({
                id: plugin.uuid,
                index: func.body.length,
                type
            });
        });
        return func;
    }).map(func => {
        func.body = flattenFunctionBody(func.body);
        return func;
    })[0];
};

export const setChangesOnCurrentData = (state, data) => {
    //  state.selectedPluginData[data.prop] = data.value;
    if (state.selectedPluginData.nodeType === "FOR" && data) {
        state.selectedPluginData.variable = data.variable;
        state.selectedPluginData.direction = data.direction;
        state.selectedPluginData.start = data.start;
        state.selectedPluginData.end = data.end;
        state.selectedPluginData.step = data.step;
    } else if (state.selectedPluginData.nodeType === "IF" && data) {
        state.selectedPluginData.condition = data.condition;
        state.selectedPluginData.trueList = data.trueList;
        state.selectedPluginData.falseList = data.falseList;
    } else if ((state.selectedPluginData.nodeType === "DO" || state.selectedPluginData.nodeType === "WHILE") && data) {
        state.selectedPluginData.condition = data.condition;
        state.selectedPluginData.trueList = data.trueList;
    } else if (state.selectedPluginData.nodeType === "CUSTOM" && data) {
        state.selectedPluginData.customCode = data.customCode;
    }
};

export const setDiagramError = (state, data) => {
    state.diagramValidationErr = data;
};
export const setSaveDigramaData = (state, data) => {
    state.saveDigramaData = data;
};

export const setScTypes = (state, data) => {
    state.bcTypes = data || [];
};

export const setScCredentials = (state, data) => {
    state.bcCredentials = data || [];
};
export const setScNetworks = (state, data) => {
    state.bcNetworks = data || [];
};

export const setCurrentContract = (state, payload) => {
    state.currentContract = payload;
};
export const setScSameNetwork = (state, payload) => {
    state.scSameNetwork = payload;
};
export const setEvent = (state, payload) => {
    state.events = payload;
};
export const setTemplate = (state, payload) => {
    state.templates = payload;
};
